import { useState, useEffect } from "react";
import { fetchBudget } from "./api";
import { App } from "antd";

const useAuthenticatedFetchData = (fromDate, toDate, isAuthenticated) => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { message } = App.useApp();

  useEffect(() => {
    // Only run the fetch if authenticated
    if (!isAuthenticated) {
      return; // Exit early if not authenticated
    }

    const fetchData = async () => {
      setLoading(true);
      try {
        const budget = await fetchBudget(fromDate, toDate);
        setData(budget);

        if (fromDate !== "All") {
          message.success("Filters applied successfully.");
          setError(false);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        // setLoading(false);
      }
    };

    fetchData();
  }, [fromDate, toDate, isAuthenticated, message]); // Re-fetch when dateRange or auth status changes

  return { data, loading, error };
};

export default useAuthenticatedFetchData;
